define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-class",
	"dojo/dom-construct",
	"dojo/dom-style",
	"dojo/query",
	"dijit/registry",
	"dijit/TitlePane",
	"csi",
	"csi/action/Delete",
	"csi/action/Edit",
	"csi/action/Insert",
	"csi/api",
	"csi/_base/underscore",
	"csi/def",
	"csi/def/Action",
	"csi/def/Actions",
	"csi/def/AddPath",
	"csi/def/Heading",
	"csi/def/Toolbar",
	"csi/gallery/Widget",
	"csi/heading/_base",
	"csi/heading/Expression",
	"csi/heading/Ref",
	"csi/heading/Renderer",
	"csi/heading/Time",
	"csi/html",
	"csi/model/comment",
	"csi/reflection",
	"csi/reflectionHints",
	"csi/sessionConstants",
	"csi/state/rootStore",
	"csi/types",
	"csi/xml",
	"dojo/text!./Gallery.html",
	"dojo/text!./Reply.html",
	"dojo/text!./Title.html",
	"csi/view/ToolbarPluginFile"
], function(declare, lang, domClass, domConstruct, domStyle, query, registry, TitlePane,
	csi, Delete, Edit, Insert, api, _, def, Action, Actions, AddPath, Heading, Toolbar, Gallery, headingBase, Expression, Ref, Renderer, Time, html,
	commentModel, reflection, reflectionHints, sessionConstants, {sessionStore}, types, xml, template, replyTemplate, titleTemplate) {

	var COMMENT = "Comment";
	var _bLastPost = false;

	var _Attachments = declare(Renderer, {
		allowEmpty: true,

		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: render list of files
			var node = ctx.getNode();
			var b;

			if (csi.objectNumberOfElements(node.Files)) {
				headingBase.toHtml(ctx, ctx.view.defView.defsByKey.Files, domConstruct.create("div", null, refNode));
				b = true;
			}

			if (node.Images.length) {
				headingBase.toHtml(ctx, ctx.view.defView.defsByKey.Images, domConstruct.create("div", null, refNode));
				b = true;
			}

			if (b) {
				domStyle.set(refNode, "display", "");
			}

			return true;
		}
	});

	var _LastPostAuthor = declare(Ref, {
		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return author of comment or its last post
			var node = ctx.getNode();

			if (_bLastPost) {
				node = ctx.cache.getNode(node.LastPost);
			}

			return node.Author;
		}
	});

	var _LastPostDate = declare(Time, {
		formatValue: function(/*Any*/value, /*String?*/fmt) {
			// summary: if same day, show time; if same year, show date without year; otherwise show date including year
			return types.formatTime(value, sessionStore.print ? types.FORMAT_DATETIME : types.FORMAT_DIFF);
		},

		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return last post date
			var node = ctx.getNode();

			if (_bLastPost) {
				node = ctx.cache.getNode(node.LastPost);
			}

			return node.Date;
		}
	});

	var _Replies = declare(Expression, {
		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return number of replies to comment
			return ctx.getNode().Replies.length;
		}
	});

	var _TitlePane = declare(TitlePane, {
		/**
		 * @override
		 * This click event does not allow navigation to links inside the titlepane, so handle here explicitly
		 */
		_onTitleClick: function(evt) {
			var domNode = evt.target;
			var href = domNode.href;
			var target = domNode.target;

			if (href) {
				if (target) {
					window.open(href, target);
				} else {
					window.location = href;
				}

				return;
			}

			this.inherited(arguments);
		},

		/**
		 * @override
		 * Add extra CSS to control border-radius of titlepane when opened
		 */
		_setCss: function() {
			this.inherited(arguments);
			domClass.toggle(this.domNode, "dijitTitlePaneOpen", this.open);
		}
	});

	return declare(Gallery, {
		dndRestrict: true,
		imageSize: reflection.IMAGE_SIZE_SMALL,
		prefClass: null,
		templateString: template,

		/** @property {DOMNode} commentHeaderNode - node containing column headers */
		commentHeaderNode: null,

		/** @property {boolean} _bAdmin - indicates if have admin rights on all comments */
		_bAdmin: false,

		/**
		 * @override
		 * Only show header node when there are comments to show
		 */
		postCreate: function() {
			var headerNode = this.commentHeaderNode;

			this.watch("queryTotalCount", function(attr, oldValue, newValue) {
				if (newValue != null) {
					html.setVisible(headerNode, !!newValue);
				}
			});

			this.inherited(arguments);
		},

		focusComment: function(/*String*/urlComment) {
			// summary: open and scroll to given comment
			var cmt = this.cacheView.getNode(urlComment);
			var refNode = this.getRefNodeByUrl(urlComment);
			var tp = registry.byNode(refNode);

			tp.get("open") || tp.toggle();

			if (cmt.LastPost != csi.EMPTY_URL) {
				refNode = html.queryDom([html.getDataAttributeSelector(html.DATA_URL, cmt.LastPost)], this.domNode, true);
			}

			_.delay(lang.hitch(this, this.scrollIntoView, refNode), 300);
		},

		getOriginalComment: function(/*Node*/node, /*Boolean*/bSelf) {
			// summary: return referenced comment if given node is a reply
			var orig = this.cacheView.getNode(node.__Parent__);
			if (orig && (orig.$Type == COMMENT)) return orig.$URL;
			if (bSelf) return node.$URL;
			return null;
		},

		highlight: function(/*DOMNode*/node, /*Boolean*/bOff, /*Boolean*/bSuspend, /*DOMNode[]?*/extras) {
			// summary: if highlighting top level comment, need to switch to TitlePane content
			this.inherited(arguments, [query(".dijitTitlePaneContentOuter", node)[0] || node, bOff, bSuspend, extras]);
		},

		loadPlugins: function() {
			// summary: initialize toolbar with all plugins, returning Deferred necessary to run before view can continue to load
			var defTb = this.defView.defToolbar;
			this.plugins = defTb.m_actions.concat(this.plugins);
			defTb.m_actions = null;
			return this.inherited(arguments);
		},

		/**
		 * Determines if the current user has access to delete a specific comment
		 * 
		 * If using normal 6.5+ behavior, this is only allowed for the author of the comment
		 * Can be switched (via csi/api.js) to use the pre 6.5 behavior to admins or 
		 *    authors if this is the last post for the top level comment
		 * @return true if the current user can delete the comment, otherwise false
		 */
		onAccessDelete: function(/*Context*/ctx, /*Action*/action) {
			if (!api.getUseLegacyCommentDeleteAccessBehavior()) {
				return this._hasNodeAccess(ctx, true);
			} else {
				return this._bAdmin || this.onAccessLastPost(ctx);
			}
		},

		onAccessLastPost: function(/*Context*/ctx, /*Action*/action) {
			// summary: check if comment has access.
			return this._hasNodeAccess(ctx, true);
		},

		postAction: function(/*Controller*/ac, /*Boolean*/bPendingAction) {
			// summary: refresh dates after any action (except for refresh)
			this.inherited(arguments);

			if (ac && (ac.m_action.m_id != "ViewRefresh")) {
				var ctx = this.getContext();

				this.getRefNodes().forEach(function(domNode) {
					ctx.readNodeContext(domNode);
					this._renderTitle(ctx, registry.byNode(domNode).titleNode);
				}, this);
			}
		},

		renderReply: function(/*Context*/ctx, /*DOMNode*/refNode) {
			// summary: append the reply to the given refNode
			var reply = html.templateToHtml(ctx, replyTemplate, this.defView.defsByKey);
			query(".galleryCommentReplies", refNode).addContent(reply).style("display", "");
			ctx.applyNodeContext(reply);
			return reply;
		},

		updateActions: function(/*String*/urlComment) {
			// summary: update the actions underneath each comment block
			var ctx = this.getContext();
			var refNode = this.getRefNodeByUrl(urlComment);
			var actions = this.relRoot.m_defActions;

			this._processActions(ctx.readNodeContext(refNode), refNode, actions, true);

			query(".galleryCommentReplies > div", refNode).forEach(function(domNode) {
				this._processActions(ctx.readNodeContext(domNode), domNode, actions, true);
			}, this);
		},

		/**
		 * Allow access if current logged in user is an Author of comment and original comment parent is not frozen.
		 * @param {Context} ctx - Context object reference that contains the context of the current focused item.
		 * @param {boolean} bCheckLastPost - if this is true, check if comment is the last post for top level comment otherwise no need to check last post.
		 * @return {boolean} true if the user has access, otherwise false
		 */
		_hasNodeAccess: function(ctx, bCheckLastPost) {
			var node = ctx.getNode();
			var orig = ctx.cache.getNode(this.getOriginalComment(node, true));
			var parent = ctx.cache.getNode(orig.__Parent__);
			return !xml.nodeIsFrozen(parent) && (node.Author == sessionConstants.userUrl) && (!bCheckLastPost || (orig.LastPost == node.$URL));
		},

		_postActionCommentsCollapse: function(/*Controller*/ac) {
			// summary: collapse all title panes
			this.getRefNodes().forEach(function(refNode) {
				var tp = registry.byNode(refNode);
				!tp.get("open") || tp.toggle();
			});
		},

		_postActionCommentsExpand: function(/*Controller*/ac) {
			// summary: expand all title panes
			this.getRefNodes().forEach(function(refNode) {
				var tp = registry.byNode(refNode);
				tp.get("open") || tp.toggle();
			});
		},

		_renderTitle: function(/*Context*/ctx, /*DOMNode*/domNode) {
			// summary: render title for given TitlePane
			_bLastPost = true;
			domConstruct.empty(domNode);
			domConstruct.place(html.templateToHtml(ctx, titleTemplate, this.defView.defsByKey), domNode);

			// to workaround problem with clicking links in titlepane, disable click events on anchors
			$("a", domNode).click(function(evt) {
				evt.preventDefault();
			});

			_bLastPost = false;
		},

		_resolveView: function() {
			// summary: set some defaults for view
			var rootNode = this.getViewNode();
			var defView = this.defView;
			defView.templatePath = "SiteAdmin/Comment/Content.html";

			// if this view is not in a popup (from RecentComments attribute), then it must be in a TDS view (PurchasedOrder)
			// and thus should not be editable as comments can be edited in the right pane
			if (!this.bPopup) {
				defView.setReadOnly(true);
			}

			// add Headings
			function add(key, params) {
				var h = _.extend(new Heading(), params);
				defView.addResource(key, true, h);
				return h;
			}

			add("Attachments", {
				m_name: "Attachments",
				classRenderer: _Attachments
			});

			add("Subject", {
				m_id: xml.ATTR_NAME,
				m_right: xml.RIGHT_NONE
			});

			add("Replies", {
				classRenderer: _Replies
			});

			add("Date", {
				m_id: "Date",
				m_right: xml.RIGHT_NONE,
				classRenderer: _LastPostDate
			});

			add("Author", {
				m_id: "Author",
				m_right: xml.RIGHT_NONE,
				classRenderer: _LastPostAuthor
			});

			add("Comment", {
				m_id: "Comment",
				m_right: xml.RIGHT_NONE
			});

			add("Files", {
				m_id: "Files",
				m_separator: " ,  "
			});

			add("Images", {
				m_id: reflection.ATTR_IMAGES,
				m_separator: ""
			}).addSubHeading(_.extend(new Heading(), {
				m_id: reflection.ATTR_THUMBNAIL
			}));

			if (rootNode) {
				this._bAdmin = xml.nodeHasAccess(rootNode, xml.RIGHT_ADMIN, "Comments");

				// add Toolbar
				defView.defToolbar = _.extend(new Toolbar(), {
					pluginsOmit: "views,filter,tableSuspend",
					m_actions: [
						_.extend(new Action(), {
							m_id: "CommentsExpand",
							m_class: "iconExpanded",
							m_typeControl: def.ACTION_ICON,
							m_accessAction: "hasContent",
							m_onAction: "_postActionCommentsExpand"
						}),
						_.extend(new Action(), {
							m_id: "CommentsCollapse",
							m_class: "iconCollapsed",
							m_typeControl: def.ACTION_ICON,
							m_accessAction: "hasContent",
							m_onAction: "_postActionCommentsCollapse"
						})
					]
				});

				// configure Relationship
				var rel = this.relRoot;
				rel.m_depPaths = ["Child:Replies"];
				rel.m_defActions = _.extend(new Actions(), {
					m_actions: [
						_.extend(new Insert(), {
							m_id: "CommentReply",
							m_rightParent: "",
							m_typeControl: def.ACTION_LINK,
							m_typeNode: "CommentReply",
							classController: "SiteAdmin.Comment.Reply",
							materialIcon: null
						}),
						_.extend(new Edit(), {
							m_accessAction: "onAccessLastPost",
							m_typeControl: def.ACTION_LINK,
							classController: "SiteAdmin.Comment.Edit",
							materialIcon: null
						}),
						_.extend(new Action(), {
							m_id: "CommentAttach",
							m_right: xml.RIGHT_WRITE,
							m_accessAction: "onAccessLastPost",
							m_typeControl: def.ACTION_LINK,
							bKeepViewEnabled: true,
							classController: "SiteAdmin.Comment.Attach"
						}),
						_.extend(new Delete(), {
							m_accessAction: "onAccessDelete",
							m_typeControl: def.ACTION_LINK,
							classController: "SiteAdmin.Comment.Delete",
							m_rightParent: "",
							materialIcon: null
						})
					]
				});
				rel.m_sorts = [{
					id: "Date",
					path: "Child:LastPost",
					descending: true
				}];

				// add extra paths to relationship based on domain class
				if (rootNode.$Type == "DocumentContainer") {
					rootNode = this.cacheView.getNode(rootNode.__Parent__);
				}

				const type = rootNode && rootNode.$Type;
				const hasCommentPaths = reflectionHints.hasCommentPaths(type);
				if (hasCommentPaths) {
					const referencedPaths = _.map(commentModel.getResolvedCommentPaths(type), function(path) {
						return _.extend(new AddPath(), {m_path: xml.path(reflection.PATH_PARENT, path)});
					});

					rel.m_addPaths = rel.m_addPaths.concat(referencedPaths);

				}

				add("Owner", {
					m_id: xml.ATTR_TYPE,
					m_name: "Owner",
					m_path: xml.path(xml.ATTR_PARENT, commentModel.ATTR_NAMED_PARENT),
					m_right: xml.RIGHT_NONE
				}).addSubHeading(_.extend(new Heading(), {
					m_id: xml.ATTR_NAME,
					m_right: xml.RIGHT_NONE,
					m_separator: ": "
				}));

			}

			this.inherited(arguments);
		},

		_toHtmlResult: function(/*Context*/ctx, /*DOMNode*/refNodeParent, /*DOMNode?*/refNode, /*DOMNode?*/refNodeNext, /*Actions?*/actions, /*Boolean*/bNew) {
			// summary: wrap each block in TitlePane - if printing or inserting new comment, default to open
			var bOpen = ctx.bPrint || !!refNodeNext;
			var tp = new _TitlePane({open: bOpen});

			// add CSS class to TitlePane root node when opened (not just titleNode)
			if (bOpen) {
				domClass.add(tp.domNode, "dijitTitlePaneOpen");
			}

			// render comment title
			this._renderTitle(ctx, tp.titleNode);

			// render comment content with titlepane acting as refNode
			refNode = this.inherited(arguments, [ctx, tp.containerNode, tp.domNode, null, actions, bNew]);

			// render replies
			this.getContext(null, ctx.getNodeURL(), "Replies").forEachChild(function(ctxReply) {
				var domReply = this.renderReply(ctxReply, refNode);

				if (actions) {
					this._processActions(ctxReply, domReply, actions);
				}
			}, this);

			// add titlepane to view
			tp.placeAt(refNodeParent, refNodeNext ? "first" : null);
			tp.startup();

			return refNode;
		}
	});
});